import { render, staticRenderFns } from "./dns.vue?vue&type=template&id=68cbbe47&scoped=true&"
import script from "./dns.vue?vue&type=script&lang=js&"
export * from "./dns.vue?vue&type=script&lang=js&"
import style0 from "./dns.vue?vue&type=style&index=0&id=68cbbe47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cbbe47",
  null
  
)

component.options.__file = "dns.vue"
export default component.exports